import { GET_CHANNEL_USER_COUNT, SET_GOTCHA_LOADING } from '../types';

const initState = {
  usersCount: 0,
  loading: true
};

const watercoolerReducer = (state = initState, action = {}) => {
  switch (action.type) {
    case GET_CHANNEL_USER_COUNT:
      return { ...state, usersCount: action.payload, loading: false };
    case SET_GOTCHA_LOADING:
      return { ...state, loading: action.payload };
    default:
      return state;
  }
};

export default watercoolerReducer;
